module.exports = __webpack_public_path__ + "img/driverC.82060e02.png";